import { FC } from "react";
import ContrastIcon from "@mui/icons-material/Contrast";
import { SxProps } from "@mui/material";
import {
	AccountIcon,
	ArrowDonwIcon,
	Co2Icon,
	DarkIcon,
	DataIcon,
	HomeIcon,
	LogOutIcon,
	ServicesIcon,
	SettingsIcon,
	ThemeIcon,
	WhatIfIcon,
} from "../../../../../../assets/icons";
import { AppMenuKey } from "../../../../../../common/routesUtils";
import { ThemeMode } from "../../../../../../state/preferences";

interface Props {
	target?: AppMenuKey | ThemeMode;
	sx?: SxProps;
}

/**
 * MenuIcon renders the appropriate icon for the given section and
 * according to menu state (opened, closed).
 *
 * @param target     the app section or theme mode (dark, light, system)
 * @param sx     the app section or theme mode (dark, light, system)
 * @returns          the application menu for the given section
 */
const MenuIcon: FC<Props> = ({ target, sx }) => {
	if (!target) {
		return <></>;
	}

	switch (target) {
		// Navigation
		case AppMenuKey.PostSignInHome:
			return <HomeIcon />;
		case AppMenuKey.DataCollection:
			return <DataIcon />;
		case AppMenuKey.Results:
			return <Co2Icon />;
		case AppMenuKey.WhatIf:
			return <WhatIfIcon />;
		case AppMenuKey.AdditionalServices:
			return <ServicesIcon />;
		case AppMenuKey.Settings:
			return <SettingsIcon />;
		case AppMenuKey.Account:
			return <AccountIcon />;

		// Actions items
		case AppMenuKey.Theme:
			return <ThemeIcon />;
		case AppMenuKey.SignOut:
			return <LogOutIcon />;

		case AppMenuKey.ArrowDown:
			return <ArrowDonwIcon style={sx} />;

		// Theme modes
		case "dark":
			return <DarkIcon style={{ height: "20px" }} />;
		case "light":
			return <ThemeIcon style={{ height: "20px" }} />;
		case "system":
			return <ContrastIcon />;
		default:
			return <></>;
	}
};

export { MenuIcon };
